import { Container, Typography, Button, CircularProgress, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { useSubscription } from '../../contexts/SubscriptionContext';


const SuccessSubscription = () => {
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const returnUrl = searchParams.get('returnUrl');
   const { currentUser } = useUser();
   const { fetchUserSubscriptions } = useSubscription();
   const [refreshingSubscription, setRefreshingSubscription] = useState(true);

   useEffect(() => {
      const refreshSubscriptionData = async () => {
         if (!currentUser?.email) {
            setRefreshingSubscription(false);
            return;
         }

         try {
            // Force refresh subscription data after successful payment
            await fetchUserSubscriptions(true);
         } catch (error) {
            console.error('❌ Error refreshing subscription data:', error);
         } finally {
            setRefreshingSubscription(false);
         }
      };

      // Refresh subscription data immediately when component mounts
      refreshSubscriptionData();
   }, [currentUser?.email, fetchUserSubscriptions]);

   useEffect(() => {
      // Only redirect after subscription data has been refreshed
      if (!refreshingSubscription) {
         const redirectDelay = setTimeout(() => {
            if (returnUrl) {
               const decodedUrl = decodeURIComponent(returnUrl);
               navigate(decodedUrl, { replace: true });
            } else {
               navigate('/dashboard', { replace: true }); // Go to dashboard
            }
         }, 2000); // Reduced delay since we've already refreshed the data

         return () => clearTimeout(redirectDelay);
      }
   }, [returnUrl, refreshingSubscription, navigate]);

   return (
      <Container
         sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 5,
            height: '100%',
         }}
      >
         <Typography sx={{ marginBottom: 2 }} variant='h4'>
            Subscription successful
         </Typography>
         <Typography sx={{ marginBottom: 2 }} variant='body1'>
            You can now access all of our features.
         </Typography>

         {refreshingSubscription ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
               <CircularProgress size={24} />
               <Typography variant='body2' sx={{ mt: 1, color: 'text.secondary' }}>
                  Loading...
               </Typography>
            </Box>
         ) : (
            <Typography variant='body2' sx={{ mb: 2, color: 'text.secondary' }}>
               Redirecting...
            </Typography>
         )}

         <Button
            variant='contained'
            color='primary'
            onClick={() => navigate('/dashboard')}
            disabled={refreshingSubscription}
            sx={{ mt: 2 }}
         >
            Go to dashboard
         </Button>
      </Container>
   );
};

export default SuccessSubscription;
